import { useState } from 'react';
import { BodyConfirmModal } from './body/body_confirm_modal.component';
import { InfoModal } from './info_modal.component';


interface ConfirmNavModalProviderProp {
  onConfirm: () => void;
  onClose?: () => void;
  t: ( key: string ) => string;
}

export const ConfirmNavModal: React.FC<ConfirmNavModalProviderProp> = ( { onConfirm, onClose, t }: ConfirmNavModalProviderProp ) => {
  const [ isOpen, setIsOpen ] = useState( true );

  const close = () => {
    setIsOpen( false );
    if ( onClose ) {
      onClose();
    }
  };

  const confirm = () => {
    onConfirm();
    close();
  };

  return (
    <>
      {
        isOpen &&
          <InfoModal
            id={ 'confirm_nav_modal' }
            title={ t( 'Are you sure ?' ) }
            isOpen={ isOpen }
            onClose={ close }
            hasCross={ false }
          >
            <BodyConfirmModal
              onCancel={ close }
              onConfirm={ confirm }
              confirmColor='#4986f3'
              confirmColorHover='#3579F2'
            >
              <div className='p-2'>
                { t( 'You\'ll lose the information you\'ve entered !' ) }
              </div>
            </BodyConfirmModal>
          </InfoModal>
      }
    </>
  );
};